import Table from "./Table";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";

export default Table;

export { TableBody, TableHeader };